import _ from 'lodash';
import { decode } from 'jsonwebtoken';
import store from '../redux-store';

/**
 * @returns {Object} { isAuthenticated }
 */
export default () => {
  const state = store.getState();
  const jwt = state.app.token;

  const isAuthenticated = () => {
    if (!_.isNil(jwt)) {
      const decoded = decode(jwt);
      if (decoded && decoded.exp > new Date().getTime() / 1000) {
        return true;
      }
    }

    return false;
  };

  return { isAuthenticated };
};
